export interface VirtualAppointmentListTab<T extends string> {
    key: T;
    label: string;
    count: number;
}

interface VirtualAppointmentListTabsProps<T extends string> {
    tabs: readonly VirtualAppointmentListTab<T>[];
    activeKey: T;
    onSelect: (key: T) => void;
    /** Spread the tabs evenly across the list width. */
    fill?: boolean;
}

// Pinned above the VA list; same pills as the work-queue side panel tabs.
export function VirtualAppointmentListTabs<T extends string>({
    tabs,
    activeKey,
    onSelect,
    fill = false
}: VirtualAppointmentListTabsProps<T>) {
    return (
        <div
            role="tablist"
            className="flex-shrink-0 flex items-center gap-1 px-2 py-1.5 border-b border-gray-200"
        >
            {tabs.map((tab) => {
                const active = tab.key === activeKey;
                return (
                    <button
                        key={tab.key}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        onClick={() => onSelect(tab.key)}
                        className={`inline-flex items-center gap-1.5 whitespace-nowrap px-2.5 py-1 rounded-md text-[11px] font-semibold transition-colors ${
                            fill ? 'flex-1 justify-center' : ''
                        } ${active ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        {tab.label}
                        {tab.count > 0 && (
                            <span className="inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-gray-200 text-gray-700 text-[10px] font-bold leading-none">
                                {tab.count}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
